/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PaymentGatewayType {
    STRIPE = 'STRIPE',
    NOW_PAYMENTS = 'NOW_PAYMENTS',
    APPLE_IAP = 'APPLE_IAP',
    GOOGLE_IAP = 'GOOGLE_IAP',
    CRYPTO = 'CRYPTO',
    ADMIN = 'ADMIN',
    TRIAL = 'TRIAL',
}
